import AuthService from '@services/AuthService';
import axios from '@services/InterceptorsForAxiosRequests';
import { buildQueryString } from '@utils/Functions';
import { licensesApi } from '@routes/api';
import { getTableFilters } from '@licencias/utils/functions';

export class License {
  async newLicense(data) {
    const token = AuthService.getAuthHeader();
    const filters = buildQueryString({});
    const path = licensesApi.license(filters);
    const body = data;
    const response = await axios.post(path, body, token);
    return response.data;
  }

  async newLicenseNotMedical(data) {
    const token = AuthService.getAuthHeader();
    const filters = buildQueryString({});
    const path = licensesApi.notMedical(filters);
    const body = data;
    const response = await axios.post(path, body, token);
    return response.data;
  }

  uploadDocuments({ formData, id_license, medical_confidentiality = false }) {
    const token = AuthService.getAuthHeaderMultipart();
    const filters = buildQueryString({
      id_license: id_license,
      medical_confidentiality: medical_confidentiality,
    });
    const path = licensesApi.documentsUpload(filters);
    const body = formData;
    return axios.post(path, body, token);
  }

  uploadCertificate({ formData, id_license, medical_confidentiality = false }) {
    const token = AuthService.getAuthHeaderMultipart();
    const filters = buildQueryString({
      id_license: id_license,
      medical_confidentiality: medical_confidentiality,
    });
    const path = licensesApi.certificate(filters);
    const body = formData;
    return axios.post(path, body, token);
  }

  newTagEmployees(data) {
    const token = AuthService.getAuthHeader();
    const filters = buildQueryString({});
    const path = licensesApi.tags(filters);
    const body = data;
    return axios.post(path, body, token);
  }

  editTagEmployes(data) {
    const token = AuthService.getAuthHeader();
    const filters = buildQueryString({ etiqueta: data?.oldTag });
    const path = licensesApi.tags(filters);
    const body = data;
    return axios.patch(path, body, token);
  }

  deleteTagEmployes(tag) {
    const token = AuthService.getAuthHeader();
    const filters = buildQueryString({ etiqueta: tag });
    const path = licensesApi.tags(filters);
    return axios.delete(path, token);
  }

  getBossTagsEmployees(params) {
    const token = AuthService.getAuthHeader();
    const filters = getTableFilters(params);
    const path = licensesApi.tagsAutocomplete(filters);
    return axios.get(path, token);
  }

  async editBossTagsEmployees(data) {
    const token = AuthService.getAuthHeader();
    const filters = buildQueryString({});
    const path = licensesApi.tagsEdit(data?.idUser, filters);
    const body = data;
    const response = axios.patch(path, body, token);
    return response.data;
  }

  getBossWarningsLicenses(params) {
    const token = AuthService.getAuthHeader();
    const filters = getTableFilters(params);
    const path = licensesApi.bossWarnings(filters);
    return axios.get(path, token);
  }

  uploadMedicalExtension({ formData, id_license }) {
    const token = AuthService.getAuthHeaderMultipart();
    const filters = buildQueryString({});
    const path = licensesApi.medicalExtension(id_license, filters);
    const body = formData;
    return axios.patch(path, body, token);
  }

  uploadAndSendMessage({ formData, id_license }) {
    const token = AuthService.getAuthHeaderMultipart();
    const filters = buildQueryString({ id_license: id_license });
    const path = licensesApi.documentsUploadMessage(filters);
    const body = formData;
    return axios.post(path, body, token);
  }

  cancelLicense(id) {
    const token = AuthService.getAuthHeader();
    const filters = buildQueryString({});
    const path = licensesApi.currentUserCancelById(id, filters);
    const body = {};
    return axios.patch(path, body, token);
  }

  hasErrors({ licenseType, from_date, to_date, modality }) {
    const token = AuthService.getAuthHeader();
    const filters = buildQueryString({
      license_type: licenseType,
      from_date: from_date,
      to_date: to_date,
      modality: modality,
    });
    const path = licensesApi.warnings(filters);
    return axios.get(path, token);
  }

  getAdelantoVacacional(params) {
    const token = AuthService.getAuthHeader();
    const filters = buildQueryString(params);
    const path = licensesApi.adelantoVacacional(filters);
    return axios.get(path, token);
  }

  getAllLicenses(params) {
    const token = AuthService.getAuthHeader();
    const filters = getTableFilters(params, true);
    const path = licensesApi.currentUser(filters);
    return axios.get(path, token);
  }

  getLicensesBoss(params, sort) {
    const token = AuthService.getAuthHeader();
    const filters = getTableFilters(params, sort);
    const path = licensesApi.bossLicenses(filters);
    return axios.get(path, token);
  }

  getGanttLicensesBoss(params) {
    const token = AuthService.getAuthHeader();
    const filters = getTableFilters(params, true);
    const path = licensesApi.gantt(filters);
    return axios.get(path, token);
  }

  getLicensesActives(params, sort) {
    const token = AuthService.getAuthHeader();
    const filters = getTableFilters(params, sort);
    const path = licensesApi.currentUser(filters);
    return axios.get(path, token);
  }

  getLicenseById(id) {
    const token = AuthService.getAuthHeader();
    const filters = buildQueryString({});
    const path = licensesApi.licenseById(id, filters);
    return axios.get(path, token);
  }

  approvalHandler({ event, id, description }) {
    const token = AuthService.getAuthHeader();
    const filters = buildQueryString({});
    const path = licensesApi.eventHandler(id, event, filters);
    const body = { description };
    return axios.patch(path, body, token);
  }

  getDocument(id) {
    const token = AuthService.getAuthHeaderBlob();
    const filters = buildQueryString({});
    const path = licensesApi.certificateById(id, filters);
    return axios.get(path, token);
  }

  getHolidays() {
    const token = AuthService.getAuthHeader();
    const filters = buildQueryString({ sort_order: 1 });
    const path = licensesApi.feriados(filters);
    return axios.get(path, token);
  }

  getOtherLicensesPageLink() {
    const token = AuthService.getAuthHeader();
    const filters = buildQueryString({});
    const path = licensesApi.otras(filters);
    return axios.get(path, token);
  }

  async newManualLicense(data) {
    const token = AuthService.getAuthHeader();
    const filters = buildQueryString({
      id_user_compartido: data?.id_user_compartido,
    });
    const path = licensesApi.manual(filters);
    const body = data;
    const response = await axios.post(path, body, token);
    return response.data;
  }

  async editManualLicense(data) {
    const token = AuthService.getAuthHeader();
    const filters = buildQueryString({
      id_user_compartido: data?.id_user_compartido,
    });
    const path = licensesApi.manualById(data?.id, filters);
    const body = data;
    const response = await axios.put(path, body, token);
    return response.data;
  }

  deleteManualLicense(params) {
    const token = AuthService.getAuthHeader();
    const filters = buildQueryString({
      id_user_compartido: params?.id_user_compartido,
    });
    const path = licensesApi.manualById(params?.id_license, filters);
    return axios.delete(path, token);
  }
}

export const LicenseService = new License();
